import * as React from "react";
const SvgItalic = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 32, viewBox: "0 0 32 32", width: 32, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 8V11H16.21L12.79 19H10V22H18V19H15.79L19.21 11H22V8H14Z", fill: "currentColor" }));
export default SvgItalic;
